import { useCallback, useMemo } from 'react'
import { Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { EditLinkCatalogToWholesaler, NewLinkCatalogToWholesaler } from './LinkCatalogToWholesaler'
import { Alert } from '@mui/material'
import { WholesalerCatalogDetails } from './WholesalerCatalogDetails'
import { useGetWholesalerCatalog } from 'app-support/wholesale/hooks/useGetWholesalerCatalog'

export const WholesalerCatalog = () => {
  const { wholesaleUUID } = useParams<{ wholesaleUUID?: string }>()
  const navigation = useHistory()
  const { url, path } = useRouteMatch()
  const { t } = useTranslation()
  const { data } = useGetWholesalerCatalog(wholesaleUUID)
  const cat = useMemo(() => data?.[0], [data])
  const goBack = useCallback(() => navigation.push(url), [url, navigation])

  if (!wholesaleUUID) return <Alert color='info'>{t('wholesaler-catalog.message')}</Alert>
  if (!cat) return <NewLinkCatalogToWholesaler />
  return (
    <Switch>
      <Route path={`${path}/edit-catalog`} render={() => <EditLinkCatalogToWholesaler cat={cat} onLink={goBack} />} />
      <Route path={path} render={() => <WholesalerCatalogDetails cat={cat} wholesalerUUID={wholesaleUUID} />} />
    </Switch>
  )
}
